import { application } from "./application"
import { FormRefreshController } from "./form_refresh_controller"

application.register("form-refresh", FormRefreshController)